import {Type} from "@angular/core";
import { SystemComponent } from './system.component';

export * from "./system.component";

export const SYSTEMINFO_DIRECTIVES: Type<any>[] = [
    SystemComponent
];
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
